import React from "react";
import { Home } from "components/Home";

const Cnt_Home: React.FC<any> = (props) => {
  return <Home />;
};

export default Cnt_Home;
